$(document).ready(function () {
  $('.pdp-main__made-fy-btn').appendTo('.pdp-main__made-fy-description p');

  // ------------------------ Popup Upsell Timer -----------------------------------
  function PopupUpsellTimer() {
    const popup = $('.popup-upsell'),
      popup_timer = popup.find('.popup-upsell__timer');

    if (!popup_timer.length) return { start: () => { }, stop: () => { } };

    const timer = popup_timer.find('.countdown');
    let time = parseInt(popup_timer.data('timer'), 10) * 60,
      timerInterval;

    const formatTime = t => [Math.floor(t / 3600), Math.floor((t % 3600) / 60), t % 60]
      .map(v => v.toString().padStart(2, '0')).join(':');

    const update = () => {
      if (time < 0) {
        clearInterval(timerInterval);
        popup.removeClass('active').find('.popup-upsell__decline').trigger('click');
        return;
      }
      timer.text(formatTime(time--));
    };

    popup.on('click', e => {
      if ($(e.target).hasClass('modal-overlay')) {
        popup.removeClass('active');
        clearInterval(timerInterval);
        popup.find('.popup-upsell__decline').trigger('click');
      }
    });

    return {
      start: () => { time = parseInt(popup_timer.data('timer'), 10) * 60; update(); timerInterval = setInterval(update, 1000); },
      stop: () => timerInterval && clearInterval(timerInterval)
    };
  }

  // Initialize popup upsell timer
  window.popupUpsellTimer = PopupUpsellTimer();


  // ------------------------------------ Initialize Modals -------------------------------------------
  handleModal('#fees-modal', '.pdp-main__fees-btn');
  handleModal('#made-fy-modal', '.pdp-main__made-fy-btn');

  $('.modal-trigger__info-icon').each(function () {
    const modal = $(this).data('modal');
    handleModal(`#${modal}`, `.modal-trigger__info-icon[data-modal="${modal}"]`);
  });


  // ------------------------------------ UPSell -------------------------------------------

  // Variant Selectors
  $('.pdp-upsell__item-footer .main-select__item').on('click', function () {
    try {
      const $footer = $(this).closest('.pdp-upsell__item-footer');
      const $item = $footer.closest('.pdp-upsell__item');
      // Get selected metal and size from the open dropdowns
      const metal = $item.find('[data-type="metal"] .main-select__item[data-selected="true"]').data('metal');
      const size = $item.find('[data-type="size"] .main-select__item[data-selected="true"]').data('size');
      const $variant = $(`#pdp-upsell-variant-data input[data-metal="${metal}"][data-size="${size}"]`);

      // Update image
      updateImageMetalSrcset('.pdp-upsell__item-image img.product-image', metal);

      if ($variant.length) {
        // Update metal text
        $item.find('.pdp-upsell__item-metal').text($variant.data('metal-name'));
        // Update price
        const price = $variant.data('price');
        const currency = $('#pdp-upsell-variant-data').data('currency').replace('0.00', '').replace('0,00', '');
        $item.find('.pdp-upsell__item-prices h3').text(`${currency}${price / 100}`);
        $item.find('.pdp-upsell__item-prices s').text(`${currency}${(price * 1.4 / 100).toFixed(2)}`);
      }
    } catch (error) {
      console.error('Error updating upsell variant:', error);
    }
  });


  // Handle upsell add to cart
  $('.pdp-upsell__item-atc').on('click', function () {
    const $upsellItem = $(this).closest('.pdp-upsell__item');
    const selectedMetal = $upsellItem.find('[data-type="metal"] .main-select__item[data-selected="true"]').data('metal');
    const selectedSize = $upsellItem.find('[data-type="size"] .main-select__item[data-selected="true"]').data('size');

    // Find the correct variant ID from hidden data
    const $selectedVariant = $(`#pdp-upsell-variant-data input[data-metal="${selectedMetal}"][data-size="${selectedSize}"]`);
    const id = $selectedVariant.val();
    if (id) {
      const $btn = $(this);
      $btn.prop('disabled', true)
        .find('>*').addClass('hidden').end()
        .find('.loading__spinner').removeClass('hidden');

      $.post('/cart/add.js', { items: [{ id, quantity: 1 }] })
        .done(() => { window.cart_open(); window.cart_build(); })
        .fail(() => alert('Error adding item to cart.'))
        .always(() => {
          setTimeout(() => {
            $btn.prop('disabled', false)
              .find('>*').removeClass('hidden').end()
              .find('.loading__spinner').addClass('hidden');
          }, 2000);
        });
    }
  });
});